import { render, staticRenderFns } from "./blockLabel-gray.vue?vue&type=template&id=31ae0b08&scoped=true&"
import script from "./blockLabel-gray.vue?vue&type=script&lang=js&"
export * from "./blockLabel-gray.vue?vue&type=script&lang=js&"
import style0 from "./blockLabel-gray.vue?vue&type=style&index=0&id=31ae0b08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ae0b08",
  null
  
)

export default component.exports